/* eslint-disable max-len */
/* eslint-disable vue/max-len */

import {
  boolFromValue, boolToValue, numberFromValue, numberToValue, stringFromValue, stringToValue,
} from '@/api/api-utils';
import * as pbs from '@/grpc-gen/settings_service_pb';
import { isModelEqualToModel } from '@/model/model-utils';

const prefix = (name: string): string => `Widget${name.charAt(0).toUpperCase()}${name.slice(1)}`;

export interface WidgetAccountSetingsMapping {}

export interface IWidgetAccountSettings {

  color?: string;

  locale?: string;

  useHtmlLanguage?: boolean;

  open?: boolean;

  useTerms?: boolean;

  useTermsUrl?: string;

  useNewsletterSubscription?: boolean;

  useNewsletterSubscriptionOptIn?: boolean;

  showFab?: boolean;

  showGiftCardFab?: boolean;

  fabText?: string;

  useMaxPartySizeLink?: boolean;

  usePartySizeBreakdown?: boolean;

  usePartySizeChildSeatsBreakdown?: boolean;

  useReservationNotes?: boolean;

  useAllergiesToggle?: boolean;

  useRestaurantPhone?: boolean;

  useRestaurantEmail?: boolean;

  additionalContactData?: string[];

  messageFullyBooked?: string;

  messageNoAvailability?: string;

  messageClosed?: string;

  //
  translations?: string;

  welcomeMessage?: string;

  extraInfo?: string;
}

export default class WidgetAccountSettings implements IWidgetAccountSettings {
  static readonly DEFAULTS: IWidgetAccountSettings = {
    useReservationNotes: true,
    useAllergiesToggle: true,
    useNewsletterSubscription: true,
    useRestaurantPhone: true,
    useRestaurantEmail: true,
    useMaxPartySizeLink: true,
    useTerms: false,
    showGiftCardFab: true,
    open: true,
    showFab: true,
    messageClosed: '',
    messageNoAvailability: '',
    messageFullyBooked: '',
  };

  id = 0;

  // boolParam?: boolean;

  // numberParam?: number;

  // stringParam?: string;
  //

  color?: string;

  locale?: string;

  useHtmlLanguage?: boolean;

  open?: boolean;

  useTerms?: boolean;

  useTermsUrl?: string;

  useNewsletterSubscription?: boolean;

  useNewsletterSubscriptionOptIn?: boolean;

  showFab?: boolean;

  showGiftCardFab?: boolean;

  fabText?: string;

  useMaxPartySizeLink?: boolean;

  usePartySizeBreakdown?: boolean;

  usePartySizeChildSeatsBreakdown?: boolean;

  useReservationNotes?: boolean;

  useAllergiesToggle?: boolean;

  useRestaurantPhone?: boolean;

  useRestaurantEmail?: boolean;

  additionalContactData?: string[];

  messageFullyBooked?: string;

  messageNoAvailability?: string;

  messageClosed?: string;

  //
  translations?: string;

  welcomeMessage?: string;

  extraInfo?: string;

  static fromGrpcResponse(r: pbs.AccountSettingsResponse, m?: WidgetAccountSetingsMapping): WidgetAccountSettings {
    return WidgetAccountSettings.fromGrpcModel(r.settings, m);
  }

  static fromGrpcModel(o?: Record<string, string>, m?: WidgetAccountSetingsMapping): WidgetAccountSettings {
    const p = new WidgetAccountSettings();

    // p.boolParam = boolFromValue(o?.get(prefix('boolParam'))) ?? false;
    // p.numberParam = numberFromValue(o?.get(prefix('numberParam'))) ?? 0;
    // p.stringParam = stringFromValue(o?.get(prefix('stringParam'))) ?? '';

    p.color = o?.[prefix('color')];
    p.useHtmlLanguage = boolFromValue(o?.[prefix('useHtmlLanguage')]);
    p.open = boolFromValue(o?.[prefix('open')]) ?? WidgetAccountSettings.DEFAULTS.open;
    p.useTerms = boolFromValue(o?.[prefix('useTerms')]) ?? WidgetAccountSettings.DEFAULTS.useTerms;
    p.useTermsUrl = o?.[prefix('useTermsUrl')];
    p.locale = o?.[prefix('locale')];

    p.useNewsletterSubscription = boolFromValue(o?.[prefix('useNewsletterSubscription')]) ?? WidgetAccountSettings.DEFAULTS.useNewsletterSubscription;
    p.useNewsletterSubscriptionOptIn = boolFromValue(o?.[prefix('useNewsletterSubscriptionOptIn')]);

    p.showFab = boolFromValue(o?.[prefix('showFab')]) ?? WidgetAccountSettings.DEFAULTS.showFab;
    p.showGiftCardFab = boolFromValue(o?.[prefix('showGiftCardFab')]) ?? WidgetAccountSettings.DEFAULTS.showGiftCardFab;
    p.fabText = o?.[prefix('fabText')];

    p.useMaxPartySizeLink = boolFromValue(o?.[prefix('useMaxPartySizeLink')]) ?? WidgetAccountSettings.DEFAULTS.useMaxPartySizeLink;
    p.usePartySizeBreakdown = boolFromValue(o?.[prefix('usePartySizeBreakdown')]);
    p.usePartySizeChildSeatsBreakdown = boolFromValue(o?.[prefix('usePartySizeChildSeatsBreakdown')]);

    p.useReservationNotes = boolFromValue(o?.[prefix('useReservationNotes')]) ?? WidgetAccountSettings.DEFAULTS.useReservationNotes;
    p.useAllergiesToggle = boolFromValue(o?.[prefix('useAllergiesToggle')]) ?? WidgetAccountSettings.DEFAULTS.useAllergiesToggle;
    p.useRestaurantPhone = boolFromValue(o?.[prefix('useRestaurantPhone')]) ?? WidgetAccountSettings.DEFAULTS.useRestaurantPhone;
    p.useRestaurantEmail = boolFromValue(o?.[prefix('useRestaurantEmail')]) ?? WidgetAccountSettings.DEFAULTS.useRestaurantEmail;

    p.additionalContactData = o?.[prefix('additionalContactData')]?.split(',');

    p.messageFullyBooked = o?.[prefix('messageFullyBooked')] ?? WidgetAccountSettings.DEFAULTS.messageFullyBooked;
    p.messageNoAvailability = o?.[prefix('messageNoAvailability')] ?? WidgetAccountSettings.DEFAULTS.messageNoAvailability;
    p.messageClosed = o?.[prefix('messageClosed')] ?? WidgetAccountSettings.DEFAULTS.messageClosed;

    //
    p.extraInfo = o?.[prefix('extraInfo')];
    p.translations = o?.[prefix('translations')];
    p.welcomeMessage = o?.[prefix('welcomeMessage')];

    return p;
  }

  toGrpcModel(): Record<string, string> {
    const o: Record<string, string> = {};

    const pushIfChanged = <K extends keyof IWidgetAccountSettings>(
      key: K,
      currentValue: IWidgetAccountSettings[K],
      formatter: (v: IWidgetAccountSettings[K]) => string | undefined,
    ) => {
      if (currentValue !== undefined && currentValue !== WidgetAccountSettings.DEFAULTS[key]) {
        const formatted = formatter(currentValue);
        o[prefix(key)] = formatted ?? '';
      } else {
        o[prefix(key)] = '';
      }
    };

    // arr.push([prefix('boolParam'), boolToValue(this.boolParam) ?? '']);
    // arr.push([prefix('numberParam'), numberToValue(this.numberParam) ?? '']);
    // arr.push([prefix('stringParam'), stringToValue(this.stringParam) ?? '']);

    if (this.color !== undefined) pushIfChanged('color', this.color, stringToValue);
    if (this.useHtmlLanguage !== undefined) pushIfChanged('useHtmlLanguage', this.useHtmlLanguage, boolToValue);
    if (this.open !== undefined) pushIfChanged('open', this.open, boolToValue);
    if (this.useTerms !== undefined) pushIfChanged('useTerms', this.useTerms, boolToValue);
    if (this.useTermsUrl !== undefined) pushIfChanged('useTermsUrl', this.useTermsUrl, stringToValue);
    if (this.locale !== undefined) pushIfChanged('locale', this.locale, stringToValue);

    if (this.useNewsletterSubscription !== undefined) pushIfChanged('useNewsletterSubscription', this.useNewsletterSubscription, boolToValue);
    if (this.useNewsletterSubscriptionOptIn !== undefined) pushIfChanged('useNewsletterSubscriptionOptIn', this.useNewsletterSubscriptionOptIn, boolToValue);

    if (this.showFab !== undefined) pushIfChanged('showFab', this.showFab, boolToValue);
    if (this.showGiftCardFab !== undefined) pushIfChanged('showGiftCardFab', this.showGiftCardFab, boolToValue);
    if (this.fabText !== undefined) pushIfChanged('fabText', this.fabText, stringToValue);

    if (this.useMaxPartySizeLink !== undefined) pushIfChanged('useMaxPartySizeLink', this.useMaxPartySizeLink, boolToValue);
    if (this.usePartySizeBreakdown !== undefined) pushIfChanged('usePartySizeBreakdown', this.usePartySizeBreakdown, boolToValue);
    if (this.usePartySizeChildSeatsBreakdown !== undefined) pushIfChanged('usePartySizeChildSeatsBreakdown', this.usePartySizeChildSeatsBreakdown, boolToValue);

    if (this.useReservationNotes !== undefined) pushIfChanged('useReservationNotes', this.useReservationNotes, boolToValue);
    if (this.useAllergiesToggle !== undefined) pushIfChanged('useAllergiesToggle', this.useAllergiesToggle, boolToValue);
    if (this.useRestaurantPhone !== undefined) pushIfChanged('useRestaurantPhone', this.useRestaurantPhone, boolToValue);
    if (this.useRestaurantEmail !== undefined) pushIfChanged('useRestaurantEmail', this.useRestaurantEmail, boolToValue);

    if (this.messageFullyBooked !== undefined) pushIfChanged('messageFullyBooked', this.messageFullyBooked, stringToValue);
    if (this.messageNoAvailability !== undefined) pushIfChanged('messageNoAvailability', this.messageNoAvailability, stringToValue);
    if (this.messageClosed !== undefined) pushIfChanged('messageClosed', this.messageClosed, stringToValue);

    if (this.additionalContactData !== undefined) { o[prefix('additionalContactData')] = stringToValue(this.additionalContactData.join(',')) ?? ''; }

    if (this.translations !== undefined) pushIfChanged('translations', this.translations, stringToValue);
    if (this.extraInfo !== undefined) pushIfChanged('extraInfo', this.extraInfo, stringToValue);
    if (this.welcomeMessage !== undefined) pushIfChanged('welcomeMessage', this.welcomeMessage, stringToValue);
    return o;
  }

  static compare(o1: WidgetAccountSettings, o2: WidgetAccountSettings): number {
    return isModelEqualToModel(o1, o2) ? 0 : -1;
  }

  clone(): WidgetAccountSettings {
    const copy = new WidgetAccountSettings();
    Object.assign(copy, this);
    return copy;
  }
}
